export default "__VITE_ASSET__BwFc6PkW__"